import * as React from 'react';
import moment from 'moment-timezone';
import TimeUtils from 'common/utils/TimeUtils';
import DateTimePicker from 'common/components/core/form/DateTimePicker';

import { SizeEnum } from 'common/enums/UIEnums';
import DateTimeUtils, { CustomDateFormats } from 'common/utils/DateTimeUtils';

class EntityDateTimePicker extends React.PureComponent {
    handleChange = value => {
        const { onChange } = this.props;
        onChange &&
            onChange(
                value
                    ? DateTimeUtils.customFormat(
                          value,
                          CustomDateFormats.API_DATE
                      )
                    : value
            );
    };

    render() {
        const { dateFormat, value, ...rest } = this.props;
        const momentValue = TimeUtils.getMoment(
            value,
            CustomDateFormats.API_DATE
        );
        return (
            //@others-spread-end
            <DateTimePicker
                {...rest}
                value={momentValue}
                shouldTriggerOnChangeForDateTimeOutsideRange
                dateFormat={dateFormat}
                showTime={false}
                fullWidth
                size={SizeEnum.Small}
                defaultLevel="years"
                max={moment()}
                onChange={this.handleChange}
            />
        );
    }
}

export default EntityDateTimePicker;
